export interface InventoryEvent {
  type:
    | "task_created" | "task_progress" | "task_completed" | "task_failed" | "task_cancelled"
    | "inventory_changed" | "reservations_changed"
    | "move_progress" | "move_completed" | "move_failed" | "move_cancelled";
  payload: any;
  timestamp: string;
}

export type InventoryEventHandler = (event: InventoryEvent) => void;

let eventSource: EventSource | null = null;
let refCount = 0;
const handlers = new Set<InventoryEventHandler>();

export function subscribeInventoryEvents(handler: InventoryEventHandler): () => void {
  handlers.add(handler);
  refCount++;

  if (!eventSource) {
    eventSource = new EventSource("/api/Inventory/events");
    eventSource.addEventListener("message", (e: MessageEvent) => {
      try {
        const evt: InventoryEvent = JSON.parse(e.data);
        for (const h of handlers) h(evt);
      } catch {}
    });
    eventSource.addEventListener("error", () => {
      // EventSource auto-reconnects
    });
  }

  return () => {
    handlers.delete(handler);
    refCount--;
    if (refCount <= 0 && eventSource) {
      eventSource.close();
      eventSource = null;
      refCount = 0;
    }
  };
}
